<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15.89,14.56C15.89,14.56,15.89,14.56,15.89,14.56C15.89,14.56,11.9,6.56,11.9,6.56C11.9,6.56,11.89,6.56,11.89,6.56C11.72,6.23,11.39,6,11,6C10.61,6,10.28,6.23,10.11,6.56C10.11,6.56,10.1,6.56,10.1,6.56C10.1,6.56,9,8.76,9,8.76C9,8.76,7.17,7.38,7.17,7.38C7.17,7.38,7.4,7.2,7.4,7.2C7.4,7.2,7.4,7.2,7.4,7.2C8.37,6.47,9,5.31,9,4C9,4,9,3,9,3C9,3,10,3,10,3C10.55,3,11,2.55,11,2C11,1.45,10.55,1,10,1C10,1,7,1,7,1C7,0.45,6.55,0,6,0C6,0,5,0,5,0C4.45,0,4,0.45,4,1C4,1,1,1,1,1C0.45,1,0,1.45,0,2C0,2.55,0.45,3,1,3C1,3,7,3,7,3C7,3,7,4,7,4C7,4.66,6.68,5.25,6.18,5.61C6.18,5.61,6.18,5.61,6.18,5.61C6.18,5.61,5.5,6.12,5.5,6.12C5.5,6.12,4.82,5.62,4.82,5.62C4.82,5.62,4.82,5.62,4.82,5.62C4.32,5.25,4,4.66,4,4C4,4,2,4,2,4C2,5.31,2.63,6.47,3.6,7.2C3.6,7.2,3.6,7.2,3.6,7.2C3.6,7.2,3.83,7.37,3.83,7.37C3.83,7.37,1.4,9.2,1.4,9.2C1.4,9.2,1.41,9.21,1.41,9.21C1.17,9.4,1,9.67,1,10C1,10.55,1.45,11,2,11C2.23,11,2.42,10.91,2.59,10.79C2.59,10.79,2.6,10.8,2.6,10.8C2.6,10.8,5.5,8.63,5.5,8.63C5.5,8.63,8.1,10.58,8.1,10.58C8.1,10.58,6.11,14.56,6.11,14.56C6.11,14.56,6.12,14.56,6.12,14.56C6.05,14.69,6,14.84,6,15C6,15.55,6.45,16,7,16C7.39,16,7.72,15.77,7.89,15.44C7.89,15.44,7.9,15.44,7.9,15.44C7.9,15.44,8.62,14,8.62,14C8.62,14,13.38,14,13.38,14C13.38,14,14.1,15.45,14.1,15.45C14.1,15.45,14.11,15.45,14.11,15.45C14.28,15.77,14.61,16,15,16C15.55,16,16,15.55,16,15C16,14.84,15.95,14.69,15.89,14.56C15.89,14.56,15.89,14.56,15.89,14.56ZM9.62,12C9.62,12,11,9.24,11,9.24C11,9.24,12.38,12,12.38,12C12.38,12,9.62,12,9.62,12C9.62,12,9.62,12,9.62,12Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Translate',
} as DefineComponent
</script>
